export const apiHeaders = Object.freeze({
  Authorization: 'Authorization',
  Content_Type: 'application/json; charset=utf-8',
  X_Doctor_ID: 'X-Doctor-ID',
  X_Company_ID: 'X-Company-ID',
  X_LOGONAS_ID: 'X-Logonas-ID',
});
